import React, { FC }          from 'react';
import styled                 from 'styled-components';
import { SearchInput }        from '@components/SearchInput/SearchInput';
import { IInvoiceStatistics } from '@typings/invoiceManagement';
import { EInvoiceProperty }   from '@enums/invoiceManagement';
import { StatusDashboard }    from '../components/StatusDashboard';

interface IProps {
  push            : (path: string) => void;
  statistics      : IInvoiceStatistics | null;
  showWarning     : boolean;
  onInvoiceSearch : (searchText: string, searchProp: EInvoiceProperty) => void;
}

const StyledText = styled.div`
  margin-top  : 25px;
  margin-left : 200px;
  color       : ${({ theme: { textColor } }): string => textColor.red};
`;

export const InvoiceManagementPage: FC<IProps> = ({
  push,
  statistics,
  showWarning,
  onInvoiceSearch,
}) => (
  <>
    <SearchInput
      title         = "Search by Invoice Number:"
      labelWidth    = "200px"
      maxWidth      = "700px"
      margin        = "20px 5px 10px"
      handleSearch  = {({ searchText }) => onInvoiceSearch(searchText, EInvoiceProperty.Number)}
      searchOnReset = {false}
      validateRegex = "[0-9]"
    />

    <SearchInput
      title         = "Search by VIN #:"
      labelWidth    = "200px"
      maxWidth      = "700px"
      margin        = "20px 5px 10px"
      maxLength     = {17}
      handleSearch  = {({ searchText }) => onInvoiceSearch(searchText, EInvoiceProperty.Vin)}
      searchOnReset = {false}
      validateRegex = "[\d\w]{17}"
    />

    {showWarning && (
      <StyledText>
        The search you entered did not return any invoices. Please check the Invoice number or VIN.
      </StyledText>
    )}

    <StatusDashboard
      push       = {push}
      statistics = {statistics}
    />
  </>
);
